<template>
  <drag-modal :visible="visible" @cancel="close" title='原告权限管理' width='600px' class="treemodel" v-model="visible">
    <a-form-model-item v-if='edit == 1'>
      <a-form-model-item label="原告" style="margin:0;" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
        <a-select v-model="accuser" placeholder="请选择" style="width: 100%;">
          <a-select-option v-for="item in listAccuser" :key="item.title" :value="item.id" :disabled="item.disabled">{{
            item.title }}</a-select-option>
        </a-select>
      </a-form-model-item>
    </a-form-model-item>
    <a-form-model-item label="权限组" style="margin:0;" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
      <a-select mode="multiple" allowClear v-model="accuser_role_ids" placeholder="请选择" style="width: 100%;">
        <a-select-option v-for="item in tree" :key="item.id" :value="item.id * 1" v-if="item.status == 1">{{
          item.title
        }}</a-select-option>
      </a-select>
    </a-form-model-item>
    <!-- <a-tree v-model="checkedKeys" checkable :expanded-keys="expandedKeys" :auto-expand-parent="autoExpandParent" :tree-data="tree" @expand="onExpand" @select="onSelect" :replace-fields="replaceFields" tree-default-expand-all /> -->
    <a-form-model-item style="text-align:center;margin-top:40px;">
      <a-popconfirm title="确认提交此条数据吗?" ok-text="确定" cancel-text="取消" @confirm="confirm">
        <a-button type="primary" style="width:148px;">保存</a-button>
      </a-popconfirm>
    </a-form-model-item>
  </drag-modal>
</template>
<script>
import { addUserAccuserMenu, addUserAccuserMenuList } from '@/server/user'
export default {
  props: {
    listAccuser: Array,    //已选择的原告
    edit: Number,
    curAcc: Object,
    cktree: Array,    //選中權限
    tree: Array,
    selectedItems: Array,
    setBatchMode: {
      type: Function,
    }
  },
  watch: {
    cktree: {
      handler(newVal) {
        if (newVal) {
          this.accuser_role_ids = newVal
        }
      },
      immediate: true,
      deep: true
    }
  },
  data() {
    return {
      accuser: '',
      replaceFields: {
        children: 'child',
        title: 'title',
        key: 'id',
        value: 'id'
      },
      accuser_role_ids: [],
      visible: false,
    }
  },
  created() {
  },
  methods: {
    close() {
      this.accuser = ''
      this.accuser_role_ids = []
      this.visible = false;
    },
    confirm() {
      if (this.type == 1 && !this.accuser) {
        this.$message.error('请选择原告')
        return false;
      }
      if (this.selectedItems.length === 0) {
        // 处理单个用户的情况
        const requestData = {
          user_id: this.curAcc.user_id,
          accuser_id: this.edit === 0 ? this.curAcc.accuser_id : this.accuser,
          accuser_role_ids: this.accuser_role_ids
        };
        addUserAccuserMenu(requestData);
        this.$message.success('设置成功');
        this.$parent.getAccuser()
        this.close();
      } else {
        let accuser_ids = []
        this.selectedItems.map((data) => {
          // accuser_role_id = data.roles.map(ele => ele.accuser_role_id);
          accuser_ids.push(data.accuser_id)
        });
        addUserAccuserMenuList({
          user_id: this.selectedItems[0].user_id,
          accuser_ids: accuser_ids,
          accuser_role_ids: this.accuser_role_ids
        }).then(res => {
          this.$message.success('设置成功');
          this.setBatchMode()
          this.$parent.getAccuser()
          this.close();
        });
      }
    },
  }
}
</script>